import { render } from "./billManage_temp.vue?vue&type=template&id=bca9f6e6&scoped=true"
import script from "./billManage_temp.vue?vue&type=script&lang=js"
export * from "./billManage_temp.vue?vue&type=script&lang=js"

import "./billManage_temp.vue?vue&type=style&index=0&id=bca9f6e6&lang=scss&scoped=true"
import "./billManage_temp.vue?vue&type=style&index=1&id=bca9f6e6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca9f6e6"]])

export default __exports__